import { render } from "./IntegrationDetailView.vue?vue&type=template&id=737c53f6"
import script from "./IntegrationDetailView.vue?vue&type=script&lang=js"
export * from "./IntegrationDetailView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__